/**
 * Created by harris on 17-2-23.
 */
class RuntimeException {
  constructor(name, message) {
    this._name = name;
    this._message = message;
  }

  get name() {
    return this._name;
  }

  get message() {
    return this._message;
  }

  toString() {
    return `${this.name}::${this.message}`
  }
}

export class NetworkException extends RuntimeException {
  constructor(message) {
    super('NetworkException', message);
  }
}

export class ResponseException extends RuntimeException {
  constructor(message) {
    super('ResponseException', message);
  }
}



// WEBPACK FOOTER //
// ./src/lib/Exception.js